import { __rest } from "tslib";
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Typography } from './../../';
import { tokens } from '@getgo/chameleon-core';
const useStyles = makeStyles(() => ({
    helperText: {
        color: tokens.text02,
    },
}));
export const HelperText = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    const classes = useStyles();
    return (React.createElement(Typography, Object.assign({ variant: "caption-default-01", className: classes.helperText }, otherProps), children));
};
